import React from 'react';
import { Select } from 'alurkerja-ui';
import { FormField, IFormField } from './FormField';

interface SelectFieldProps extends IFormField {
  options?: ISelectOption[];
  placeholder?: string;
  isSearchable?: boolean;
}

export type ISelectOption = { value: string; label: string };

export const SelectField: React.FC<SelectFieldProps> = (props) => {
  return (
    <FormField
      {...props}
      render={({ field }) => {
        const selected = props?.options?.find(o => o.value == field.value);

        return (
          <Select
            key={field.value}
            defaultValue={selected}
            options={props.options}
            onChange={e => field.onChange((e as ISelectOption).value)}
            isSearchable={props.isSearchable ?? false}
            placeholder={props.placeholder}
            isDisabled={props.disabled}
          />
        );
      }}
    />
  );
};
